export const VARIATION_WEIGHT = "WEIGHT";
export const VARIATION_PIECES = "PIECES";
export const VARIATIONS = [VARIATION_WEIGHT]